import { render, staticRenderFns } from "./NuxtLinkButton.vue?vue&type=template&id=7d5d8ae7&"
import script from "./NuxtLinkButton.vue?vue&type=script&lang=js&"
export * from "./NuxtLinkButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports